import { Component, type ErrorInfo, type ReactNode } from 'react';
import { CrashScreen } from '@/components/CrashScreen';
import { reportClientError } from '@/lib/error-reporting';

interface ErrorBoundaryProps {
  children: ReactNode;
}

/**
 * The last net under a render that throws: instead of a blank page, a word
 * of apology and a way to start again, while the error goes to the API to be
 * reported. A class, because React offers no hook for this.
 */
export class ErrorBoundary extends Component<ErrorBoundaryProps, { crashed: boolean }> {
  state = { crashed: false };

  static getDerivedStateFromError(): { crashed: boolean } {
    return { crashed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    if (info.componentStack) {
      error.stack = `${error.stack ?? `${error.name}: ${error.message}`}\nComponent stack:${info.componentStack}`;
    }
    reportClientError(error);
  }

  render() {
    return this.state.crashed ? <CrashScreen /> : this.props.children;
  }
}
